import React from 'react'
import { Card, Typography, Row, Col } from 'antd'
import { CheckOutlined } from '@ant-design/icons'
import '../../css/patient_registration.scss'

const ThankYou = () => {
  const { Title } = Typography

  return (
    <Row className='thankyou'>
      <Col>
        <Card
          title={
            <>
              <Row justify='center' flex='100%'>
                <CheckOutlined className='check-circle' />
              </Row>
              <Row justify='center'>
                <Title level={1}>Thank You!</Title>
              </Row>
            </>
          }
          style={{ textAlign: 'center' }}
        >
          <Title level={4}>Your form was successfully submitted.</Title>
        </Card>
      </Col>
    </Row>
  )
}

export default ThankYou
